import React, { useRef } from "react";
import styled from "styled-components";
import tw from "tailwind.macro";
import useOnClickOutside from "utils/hooks/useOnClickOutside";
import { StyledModal } from "components/shared";
import { Button } from "components/components/atoms";
import { Copy, Heading } from "components/components/atoms";
import CheckIcon from "components/icons/Check";
import useBreakpoint from "utils/hooks/useBreakpoint";

const Modal = styled(StyledModal)`
  ${tw`bg-black-faded-light select-none w-full h-full flex justify-center`}
  z-index: 94;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 0;
`;

const StypedCheckIcon = styled(CheckIcon)`
  width: 3.5rem;
  height: 3.5rem;
`;

const ModalContent = styled.div`
  max-width: 45rem;
  ${({ isMobile }) => (isMobile ? `width: 89vw` : `width: 80vw`)}
`;

const SuccessfulModal = (props) => {
  const {
    isOpen = false,
    onClose = () => {},
    title = "",
    text = "",
    cta = "",
  } = props;

  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  const modalRef = useRef();
  useOnClickOutside(modalRef, onClose);

  return (
    <Modal isOpen={isOpen} data-aos="fade" centered>
      <ModalContent
        isMobile={isMobile}
        className="flex flex-col justify-center items-center" 
        aria-modal="true"
        role="dialog"
      >
        <div
          className="w-full h-full relative flex flex-col items-center bg-white
              rounded text-action-blue pt-8 pb-10 md:py-8 lg:pb-20 lg:pt-20 md:px-32"
          ref={modalRef}
        >
          <div>
            <StypedCheckIcon />
          </div>
          <StyledHeading className="text-center px-5 md:px-0 pt-10 pb-1 md:pb-0 tracking-tight">
            {title}
          </StyledHeading>
          <Copy className="text-center px-10 md:px-0 pb-3 leading-7">
            {text}
          </Copy>
          <div>
            <Button className="px-16" onClick={onClose}>
              {cta}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default SuccessfulModal;
